export function Footer(){
    return  <footer className="footer">
        <div className="container">
            <div className="img-title">
                <img src="images/logo.svg" alt="logo"/>
            </div>
            <div className="links">
                <div className="location">
                     <img src="images/icon-location.svg" alt="location"/>
                     <p>    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et 
    dolore magna aliqua</p>
                </div>
                <div className="phonemail">
                    <div className="phone">
                    <img src="images/icon-phone.svg" alt="phone"/>
                       <p>+1-543-123-4567</p>
                    </div>
                    <div className="email">
                    <img src="images/icon-email.svg" alt="email"/>
                         <p> example@fylo.com</p>
                    </div>
                </div>
                <div className="aboutus">
                   
                        <ul> <li>About Us</li>
                        <li><a href="#jobs">Jobs</a></li>
                        <li><a href="#pres">Press</a></li>
                        <li><a href="#Blog">Blog</a></li>
                    </ul>
                </div>
                <div className="contactus">
                
                    <ul>    <li>Contact us</li>
                    <li><a href="#Term">Term</a></li>
                        <li><a href="#privacy">Privacy</a></li>
                    </ul>
                </div>
                <div className="social-icon">
                <i className="fa-brands fa-facebook-f"></i>
                <i className="fa-brands fa-twitter"></i>
                <i className="fa-brands fa-instagram"></i>
                </div>

            </div>
        </div>
    </footer>
}
export default Footer;